import { sortLiveQueuePatients } from "@/features/LiveQueue/LiveQueue.util";
import {
  type WaitingRoomItem,
  useWaitingRoomDashboardDashboard,
} from "@/features/LiveQueue/network/useWaitingRoomDashboard";
import { useUser } from "@/network/useUser";
import { Practitioner } from "@curai/js-fhir-tools";

export const useNextAssignedPatient = (): { next: WaitingRoomItem | null } => {
  const { data: user } = useUser();
  const { data: waitingRoomData } = useWaitingRoomDashboardDashboard({
    mineOnly: true,
    abridged: true,
  });

  const practitioner = new Practitioner(user?.professional.fhir || {});
  const { myQueue } = sortLiveQueuePatients({
    patients: waitingRoomData?.patients,
    practitioner,
  });

  return { next: myQueue[0] ?? null };
};
